// extracted by mini-css-extract-plugin
export default {"fade":"BasicGridModule_fade__ZDLVk","slide-up":"BasicGridModule_slide-up__EDKUF"};